import { styled } from '@linaria/react';

export const Container = styled.div`
	padding: 12px;
`;

export const Heading = styled.div`
	margin-bottom: 8px;
`;

export const HeadingTop = styled.div`
	display: flex;
	margin-bottom: 4px;
`;

export const HeadingBottom = styled.div``;

export const Flex1 = styled.div`
	flex: 1;
`;

export const DirButton = styled.button<{ disabled: boolean }>`
	cursor: pointer;
	visibility: ${({ disabled }) => (disabled ? 'hidden' : 'visible')};

	svg {
		display: block;
		width: 20px;
		height: 20px;
	}
`;

export const Panel = styled.div``;

export const Item = styled.button`
	display: flex;
	width: 100%;
	align-items: center;
	padding: 2px 0;
	gap: 16px;
`;

export const ItemInfo = styled.div`
	flex: 1;
	padding-right: 16px;
`;
